export default {
  CoinsBanked: 0,
  CoinsPending: 0,
  CoinsClaimed: 0,
  CoinsByModule: [],
  rankingData: {},
  userPosition: 0,
  userPoints: 0,
  userLevel: [],
  progressInfo: {},
  progressDays: {},
  progressInfoModules: [],
  pendingCoins: [],
  typeCoinsValues: [],
  progressRange: '',
  LevelImage:''
}